import React, {useRef, useState, useEffect, useContext} from "react";
import {useLocation, useHistory} from "react-router-dom";

import {BsChevronCompactRight, BsChevronCompactLeft} from "react-icons/bs";
import {vdomain} from "commons/config";
import {monetize, translateType} from "commons/utils";
import {langContext} from "commons/contexts";

import ContactForm from "./ContactForm";
import BackButton from "./BackButton";

import style from "./style.module.scss";

type textType = Record<string, Record<string, string>>;

const text: textType = {
    nl: {
        in: "in",
        description: "OMSCHRIJVING",
        bedrooms: "SLAAPKAMER",
        from: "VANAF"
    },
    fr: {
        in: "À",
        description: "DESCRIPTION",
        bedrooms: "CHAMBRE",
        from: "APD"
    }
}

function SpecificProperty() {
    const [imgPos, setImgPos] = useState(0);
    const [showRight, setShowRight] = useState(true);

    const [property, setProperty] = useState<{[key: string]: any}>({});
    const [refNo, setRefNo] = useState<string>("");
    const [images, setImages] = useState([]);

    const subCnt = useRef<HTMLDivElement>(null);
    const upperCnt = useRef<HTMLDivElement>(null);

    const location = useLocation();
    const history = useHistory();

    const {lang} = useContext(langContext);

    useEffect(() => {

        (async () => {
            await new Promise(resolve => setTimeout(resolve, 1000));

            // console.log("GOT CALLED", subCnt.current?.children);
            if (!(subCnt.current?.children?.length! > 0)) return setShowRight(true);

            let lastChild: HTMLElement = subCnt.current?.lastElementChild as HTMLElement;

            const newShowRight = (upperCnt.current!.clientWidth < (lastChild.offsetLeft + lastChild.clientWidth - 200));
            console.log("COMPARISON", upperCnt.current?.clientWidth, " VS ", "(", lastChild.offsetLeft, " + ", lastChild.clientWidth, ")");
            // console.log("NEW SHOWRIGHT", newShowRight);
            // console.log(lastChild);

            (showRight !== newShowRight) && setShowRight(newShowRight);
        })();
    });

    useEffect(() => {

        const params = Object.fromEntries(new URLSearchParams(location.search));
        fetch(vdomain + "/int-search", {method: "POST", body: JSON.stringify(params)}).then(resp => {
            resp.json().then((json: Record<string, any>[]) => {
                setProperty(Object.values(json[0])[0]);
                setRefNo(Object.keys(json[0])[0]);
            })
        });

        fetch(vdomain + "/int-getFiles", {method: "POST", body: JSON.stringify({ref: params?.ref, type: "slideshow"})}).then(response => {
            response.json().then(json => {
                setImages(json);
                console.log(json);
            });
        });

        window.scrollTo(0, 0);

    //eslint-disable-next-line
    }, []);



    const moveImages = (forward: boolean) => {

        if (!(subCnt.current?.children?.length! > 0)) return;
        if (forward && (imgPos === (images.length - 1))) return;
        if (!upperCnt.current) return;
        if (!subCnt.current) return;

        const cntWidth: number = upperCnt.current.clientWidth;

        let sizes = 0;

        for (let i = subCnt.current.children.length - 1; i > imgPos; i--) {
            if (!subCnt.current.children[i]) continue;
            sizes += subCnt.current.children[i].clientWidth;
            if (sizes >= cntWidth) break;

        }

        let shrinkTo: string = "0";

        if (sizes < cntWidth) {
            shrinkTo = (subCnt.current.children[imgPos].clientWidth - (cntWidth - sizes)) + "px";
            setShowRight(false);
        }

        // console.log("SIZES", sizes, " VS ", cntWidth, " ShrinkTo ", shrinkTo);

        document.body.style.setProperty("--shrinkTo", shrinkTo);

        const currentChildIndex = Math.max(0, imgPos + (forward ? 0 : -1));
        const currentChild = subCnt.current.children[currentChildIndex];

        console.log("CUR CHD IND", currentChildIndex, "imgPos=", imgPos);

        const shrinker = (shrinkTo === "0") ? style.shrinkAnim : style.shrinkAnimCustom;

        currentChild.classList.remove(forward ? style.growAnim : style.shrinkAnim);
        if (!forward) currentChild.classList.remove(style.shrinkAnimCustom);
        currentChild.classList.add(forward ? shrinker : style.growAnim);

        const newPos = imgPos + (forward ? 1 : -1);
        console.log(forward, "pos-" + imgPos, currentChild, "to-" + newPos, "total-" + images.length);

        setImgPos(newPos);
    }


    return <div className={style.root}>
        <div className={style.container}>
            <div className={style.titleCnt}>
                <div className={style.buttonsCnt}>
                    <BackButton className={style.backButton} text="TERUG" action={() => {history.goBack();}} />
                    <BackButton className={style.backButton} text="NAAR VASTGOED" action={() => {history.push("/" + lang);}} />
                </div>
                <div className={style.title}>{translateType(property?.type, lang) || ""} {text[lang]?.in || ""} {property?.location || ""}</div>
            </div>

            <div className={style.slideshowCnt} ref={upperCnt}>
                <div className={style.arrowButtons}>
                    <BsChevronCompactLeft size="120" onClick={() => moveImages(false)} style={{visibility: (imgPos > 0) ? "visible" : "hidden"}} />
                    <BsChevronCompactRight size="120" onClick={() => moveImages(true)} style={{visibility: (showRight && (imgPos < (images.length - 1))) ? "visible" : "hidden"}} />
                </div>
                <div className={style.subCnt} ref={subCnt}>
                    {images.map((image, i) => (
                        <div className={style.imageCnt} key={image + "" + i}>
                            <img src={image} alt={image} />
                        </div>
                    ))}
                </div>
            </div>

            <div className={style.propertyDetails}>
                Ref: {refNo} | {property?.bedrooms || ""} {text[lang]?.bedrooms} | {translateType(property?.type, lang) || ""} | {text[lang]?.from || ""} {monetize(property?.price || "")}
            </div>

            <div className={style.propertyText}>
                <div className={style.title}>
                    {text[lang]?.description || ""}
                </div>

                <div className={style.lines} />
                <div className={style.lines + " " + style.bottomLine} />

                <div className={style.text}>
                    {
                        (() => {
                            if (!property) return "";
                            return property[lang + "description"] ? property[lang + "description"] : (property.description || "")
                        })()
                    }
                </div>
            </div>


            {/* <div className={style.sloganCnt}>
                <div className={style.picture} style={{ backgroundImage: `url("${"/media/images/show/sloganimages/cover.jpg"}")` }}>
                    <div className={style.filter}></div>
                    <div className={style.slogan}>Slogan</div>
                </div>
            </div> */}
        </div>

        <br />
        <br />
        <br />
        <ContactForm {...{refNo}} />

    </div>;
}

export default SpecificProperty;